$(function () {
    function initializeSlider(thisElement, parentSlider) {
        thisElement.slick({
            centerMode: true,
            centerPadding: '60px',
            infinite: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: parentSlider.find('.sliderPrevButton'),
            nextArrow: parentSlider.find('.sliderNextButton'),
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        centerMode: false,
                        variableWidth: false,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false,
                        variableWidth: false
                    }
                }
            ]
        });

        // Progress logic
        if (parentSlider.hasClass('__progress')) {
            const progressWrap = $(`
                <div class="progress-wrap">
                    <div class="progress" role="progressbar" aria-valuemin="0" aria-valuemax="100">
                        <span class="slider__label visually-hidden"></span>
                    </div>
                </div>
            `);

            thisElement.after(progressWrap);

            var progressBar = progressWrap.find('.progress');
            var progressBarLabel = progressWrap.find('.slider__label');

            thisElement.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

                progressBar
                    .css('background-size', calc + '% 100%')
                    .attr('aria-valuenow', calc);

                progressBarLabel.text(calc.toFixed(0) + '% completed');
            });
        }

        // Ensure controls visibility and correct disabled class
        updateSliderControls(thisElement, parentSlider);

        // Bind updateSliderControls on slick events
        thisElement.on('init reInit afterChange', function (event, slick, currentSlide) {
            updateSliderControls(thisElement, parentSlider);
        });
    }

    function updateSliderControls(thisElement, parentSlider) {
        var slick = thisElement.slick('getSlick');
        var totalSlides = slick.slideCount;
        var slidesToShow = slick.options.slidesToShow;
        var prevArrow = parentSlider.find('.sliderPrevButton');
        var nextArrow = parentSlider.find('.sliderNextButton');

        // Show or hide controls based on slide count
        if (totalSlides <= slidesToShow) {
            prevArrow.hide();
            nextArrow.hide();
            parentSlider.find('.progress-wrap').hide();
        } else {
            prevArrow.show();
            nextArrow.show();
            parentSlider.find('.progress-wrap').show();
        }
    }

    function destroySlider(thisElement) {
        if (thisElement.hasClass('slick-initialized')) {
            thisElement.slick('unslick');
            $(".progress-wrap").remove();
        }
    }

    // Initialize the first tab's slider
    setTimeout(function () {
        $(".tabpanel-content .slider-tabpanel-panel:first-child .slider-items").each(function () {
            var thisElement = $(this);
            var parentSlider = $(this).closest('.slider');
            initializeSlider(thisElement, parentSlider);
        });
    }, 100); // Delay to ensure rendering is complete

    $(".TabTrigger").on("click", function () {
        var targetPanelId = $(this).attr('aria-controls');
        var targetPanel = $("#" + targetPanelId);
        var thisElement = targetPanel.find('.slider-items');
        var parentSlider = targetPanel.closest('.slider');

        setTimeout(function () {
            // Destroy the existing slider instance before reinitializing
            destroySlider(thisElement);

            // initialize the slider again
            initializeSlider(thisElement, parentSlider);

            // Ensure the controls and progress are updated after reinitialization
            updateSliderControls(thisElement, parentSlider);
        }, 100);
    });
});

$(function () {
    $(".signposting-slider .slider-items").each(function () {
        var thisElement = $(this);

        thisElement.slick({
            centerMode: true,
            centerPadding: '30px',
            infinite: true,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 400,
                    settings: {
                        centerPadding: '80px',
                    }
                },
                {
                    breakpoint: 576,
                    settings: "unslick"
                }
            ]
        });
    })
});

$(function () {
    $(".gallery-slider .slider-items").each(function () {
        var thisElement = $(this);
        var break_point = 992;
        var browser_width = window.innerWidth;

        // Initialize slick slider
        thisElement.slick({
            centerMode: false,
            infinite: true,
            dots: true,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: thisElement.closest('.gallery-slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.gallery-slider').find('.sliderNextButton'),
            mobileFirst: true,
        });

        

            // Function to position the buttons
            function positionButtons() {
                var gallerySliderImage = thisElement.find('.gallery-slider-image img');

                if (browser_width >= break_point) {
                // Wait for the image to be fully loaded
                gallerySliderImage.each(function () {
                    $(this).on('load', function () {
                        var gallerySliderImageHeight = $(this).height();
                        var buttonPosition = gallerySliderImageHeight / 2;

                        thisElement.closest('.gallery-slider').find('.slider-button').css({
                            'top': buttonPosition + 'px',
                        });
                    }).each(function () {
                        if (this.complete) $(this).trigger('load');
                    });
                });
            }
        }

        // Initial button positioning
        positionButtons();

        // Ensure buttons are correctly positioned after window resize and slide change
        $(window).on('resize', positionButtons);
        thisElement.on('setPosition', positionButtons);
    });
});